var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2",attrs:{"depressed":"","loading":_vm.isLoading},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-briefcase-outline")]),_vm._v(" "+_vm._s(_vm.taskGroups.length ? _vm.$t('actions.view') : _vm.$t('actions.create'))+" "+_vm._s(_vm.$tc('workOrder.name', 1))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }